import React from 'react';

// The AnalysisSuggestion helper component is unchanged
const AnalysisSuggestion = ({ yourProduct, compData }) => {
    const myPrice = Number(yourProduct.sellingPriceMYR) || 0;
    const myCost = Number(yourProduct.perUnitCostMYR) || 0;
    const p1 = Number(compData.comp1_price) || 0;
    const p2 = Number(compData.comp2_price) || 0;

    let analysis = { title: "Awaiting Data", suggestion: "Enter competitor prices to generate an analysis.", color: "neutral" };

    const competitors = [p1, p2].filter(p => p > 0);
    if (competitors.length === 0) {
        return (
            <div className={`analysis-card ${analysis.color}`}>
                <h4>{analysis.title}</h4>
                <p>{analysis.suggestion}</p>
            </div>
        );
    }
    
    const lowestCompetitor = Math.min(...competitors);
    const highestCompetitor = Math.max(...competitors);
    const myProfit = myPrice - myCost;

    if (myPrice < lowestCompetitor) {
        analysis = {
            title: "Price Advantage",
            suggestion: `Your price is the most competitive. This is a strong position to attract customers while maintaining a profit of RM ${myProfit.toFixed(2)} per unit.`,
            color: "positive"
        };
    } else if (myPrice > highestCompetitor) {
        const isLoweringProfitable = lowestCompetitor > myCost;
        analysis = {
            title: "Price is High",
            suggestion: isLoweringProfitable
                ? `You are priced higher than all tracked competitors. To be more competitive, consider lowering your price towards RM ${lowestCompetitor.toFixed(2)}. This would still maintain a profit.`
                : `You are priced higher, but matching the lowest competitor at RM ${lowestCompetitor.toFixed(2)} would result in a loss. Hold your price and focus on justifying the value.`,
            color: "negative"
        };
    } else {
         const isMatchingProfitable = lowestCompetitor > myCost;
        analysis = {
            title: "Balanced Pricing",
            suggestion: isMatchingProfitable
                ? `Your price is positioned between competitors. Monitor sales. If needed, matching the lower price of RM ${lowestCompetitor.toFixed(2)} is a viable strategy.`
                : `You are in a balanced position. Do not lower your price to match the competitor at RM ${lowestCompetitor.toFixed(2)}, as it would be unprofitable.`,
            color: "neutral"
        };
    }

    return (
        <div className={`analysis-card ${analysis.color}`}>
            <h4>Analysis & Suggestion</h4>
            <p><strong>{analysis.title}:</strong> {analysis.suggestion}</p>
        </div>
    );
};

const AnalysisViewer = ({ analysis, productDetails, onClose }) => {
    if (!analysis || !productDetails) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content" style={{maxWidth: '800px'}}>
                {/* ADDED: Close button for the modal */}
                <button className="close-button modal-close" onClick={onClose}>&times;</button>
                <h3>Competitor Analysis for {analysis.childId}</h3>

                <div className="analysis-viewer-content">
                    <AnalysisSuggestion yourProduct={productDetails} compData={analysis} />

                    <div className="competitor-page-grid" style={{marginTop: '1.5rem'}}>
                        <div className="competitor-card">
                            <h4>Your Product</h4>
                            {/* CORRECTED: Image size is now smaller */}
                            <img src={productDetails.imageUrl} alt={productDetails.itemName} className="competitor-image-preview" style={{maxWidth: '200px'}}/>
                            <div className="spec-field-grid" style={{gridTemplateColumns: '1fr'}}>
                                <div className="spec-field"><strong>Item Name:</strong><div>{productDetails.itemName}</div></div>
                                <div className="spec-field"><strong>Your Selling Price (RM):</strong><div>{Number(productDetails.sellingPriceMYR).toFixed(2)}</div></div>
                            </div>
                        </div>
                        <div className="competitor-card">
                            <h4>Market Data</h4>
                             <div className="competitor-input-section">
                                <h5>Competitor 1: {analysis.comp1_company || 'N/A'}</h5>
                                <div className="spec-field-grid">
                                    <div className="spec-field"><strong>Price (RM):</strong><div>{Number(analysis.comp1_price).toFixed(2)}</div></div>
                                    <div className="spec-field full-span"><strong>URL:</strong><div><a href={analysis.comp1_url} target="_blank" rel="noopener noreferrer">{analysis.comp1_url}</a></div></div>
                                </div>
                            </div>
                            <hr style={{margin: '1rem 0'}}/>
                            <div className="competitor-input-section">
                                <h5>Competitor 2: {analysis.comp2_company || 'N/A'}</h5>
                                <div className="spec-field-grid">
                                    <div className="spec-field"><strong>Price (RM):</strong><div>{Number(analysis.comp2_price).toFixed(2)}</div></div>
                                    <div className="spec-field full-span"><strong>URL:</strong><div><a href={analysis.comp2_url} target="_blank" rel="noopener noreferrer">{analysis.comp2_url}</a></div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnalysisViewer;